import { render } from "./ArtisanView.vue?vue&type=template&id=255c43ec"
import script from "./ArtisanView.vue?vue&type=script&lang=js"
export * from "./ArtisanView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__